module.exports = __webpack_public_path__ + "img/GAME_TRAIN.9fddb6f3.jpg";